import { UserProfile } from './types';

export interface IRefreshTokenApiResponse {
	accessToken?: string;
	user?: UserProfile;
	ok: boolean;
	code?: number;
	redirect_url?: string;
	csrfToken?: string;
	error?: Error;
}
export let CurrentIdentity: IRefreshTokenApiResponse;

export function updateIdentity(identity: IRefreshTokenApiResponse) {
	CurrentIdentity = identity;
	return identity;
}
